import React from 'react';
import { User } from 'lucide-react';
import Tooltip from '@/components/Tooltip';

const MemberCell = ({ member, onLogin, loginLoading }) => {
  return (
    <div className="flex items-center gap-2">
      {member.image ? (
        <img
          src={member.image}
          alt={`${member.name} ${member.last_name || ''}`}
          className="w-6 h-6 rounded-full object-cover"
        />
      ) : (
        <div className="w-6 h-6 rounded-full bg-gray-200 flex items-center justify-center">
          <User className="w-4 h-4 text-gray-500" />
        </div>
      )}
      <Tooltip
        tooltipId={`login-to-user-account-${member.id}`}
        iconId={`login-to-user-account-icon-${member.id}`}
        arrow
        title="Login to User Account"
        placement="top">
        <span style={{ cursor: 'pointer' }} onClick={() => onLogin(member.id)}>
          {`${member.name} ${member.last_name || ''}`}
        </span>
      </Tooltip>
      {loginLoading && loginLoading === member.id && (
        <div className="w-4 h-4 border-2 border-solid border-primary-yellow rounded-full animate-spin" />
      )}
    </div>
  );
};

export default MemberCell;
